export const PENDO_SCOPE = 'pendo';
